export const actionTypes = {
    FetchCompetitorAnalysis: "[FetchCompetitorAnalysis] Action",
    UpdateResultsCompetitor: "[updateResultsCompetitor] Action",
    DisableSendButtonState: "[DisableSendButtonState] Action",
    FetchCompetitorDetails: "[FetchCompetitorDetails] Action",
    UpdateCompetitorDetails: "[UpdateCompetitorDetails] Action",
    SetFetchingRecordState: "[SetFetchingRecordState] Action",
    RowClicked: "[RowClicked] Action",
    ClearResults: "[ClearResults] Action",
};